<template>
  <div class="home">
    <!-- banner -->
    <div class="banner">
      <Carousel :bannerUrl="bannerList"></Carousel>
      <!-- <el-button @click="publishProduct" class="banner_btn">发布产品</el-button> -->
    </div>
    <!-- 选型 -->
    <div class="xx_box">
      <div class="sub_title">
        <span>名称选型</span>
        <!-- <span class="more" @click="handleMore('productList')">查看更多 > </span> -->
      </div>
      <div class="xx_main">
        <div class="box1">
          <!-- <span class="black_text">
            名称选型
            <span class="red_text">按名称首字母选型</span>
          </span> -->
          <div>
            <el-input
              v-model="xx_query.name"
              class="xx_input"
              placeholder="请输入名称"
              @change="handleInputMesg"
            >
            </el-input>
            <p class="el-icon-search searchP"></p>
          </div>
        </div>
        <div class="box2">
          <div
            :class="xx_query.szm == item ? 'item activeItem' : 'item'"
            v-for="(item, index) in letterList"
            :key="index"
            @click="handleSZM(item)"
          >
            {{ item }}
          </div>
        </div>
        <div class="sub_title">
          <span>参数选型</span>
          <!-- <span class="more" @click="handleMore('productList')">查看更多 > </span> -->
        </div>
        <!-- <div class="black_text">参数选型</div> -->
        <div class="box3">
          <div
            class="item"
            v-for="(item, index) in paramsList.filter((ele, ind) => {
              return ind < 4;
            })"
            :key="index"
          >
            <div v-if="item.type == 'INPUT'">
              <span class="name">{{ item.name }}</span>
              <el-input v-model="item.value" class="input-with-select">
                <template slot="suffix" v-if="item.unit">{{
                  item.unit
                }}</template>
              </el-input>
            </div>
            <div v-if="item.type == 'SELECT'">
              <span class="name">{{ item.name }}</span>
              <el-select v-model="item.value" size="small">
                <el-option
                  v-for="optionsItem in item.options"
                  :key="optionsItem.value"
                  :label="optionsItem.value"
                  :value="optionsItem.value"
                >
                </el-option>
              </el-select>
            </div>
            <div v-if="item.type == 'RADIO'">
              <span class="name">{{ item.name }}</span>
              <el-radio-group v-model="item.value" size="small">
                <el-radio
                  v-for="(optionsItem, index) in item.options"
                  :key="index"
                  :label="optionsItem.value"
                  >{{ optionsItem.value }}</el-radio
                >
              </el-radio-group>
            </div>
            <div v-if="item.type == 'CHECKBOX'">
              <span class="name">{{ item.name }}</span>
              <el-checkbox-group v-model="item.value" size="small">
                <el-checkbox
                  v-for="(optionsItem, index) in item.options"
                  :key="index"
                  :label="optionsItem.value"
                  >{{ optionsItem.value }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div v-if="item.type == 'DATE'">
              <span class="name">{{ item.name }}</span>
              <el-date-picker
                type="date"
                size="small"
                placeholder="选择日期"
                v-model="item.value"
              ></el-date-picker>
            </div>
          </div>
          <div @click="searchXX" class="btn">开始选型</div>
          <!-- :append-to-body="false" -->
          <!-- <el-popover placement="bottom-left" width="1180" trigger="click"> -->
            <div v-if="paramsListShow">
              <Parameter
                :paramsList="
                  paramsList.filter((ele, ind) => {
                    return ind > 3;
                  })
                "
                @parameterChange="parameterChange"
              />
            </div>

          <!-- </el-popover> -->
        </div>
        <p class="more_bt" @click="moreMessage">
          <img v-if="paramsListShow" src="@/assets/home/up.png" alt="">
          <img v-else src="@/assets/home/down.png" alt="">
          {{paramsListShow? '隐藏更多参数' : '展开更多参数'}}
        </p>
      </div>
    </div>
    <!-- 水泵分类 -->
    <div class="sbfl_box" :style="`background-image: url(${backgroudnImgBc})`">
      <div class="sbfl">
        <div class="content">
          <div class="fl_box" :style="`background-image: url(${backgroudnImg})`">
            <div class="sub_title">
              <span>水泵分类</span>
              <!-- <span class="more" @click="handleMore('productList')">查看更多 > </span> -->
            </div>
            <div class="fl_box_mesg">
              <p
                class="fl_box_p"
                v-for="(item, index) in classifyList"
                :key="index"
                :class="sbClassIndex == index ? 'active' : ''"
                @click="getSClass(index)"
                @mouseenter="handleMouseEnter(item, index)"
              >
                <span>{{ item.name }}</span>
                <img :src="sbClassIndex == index ? item.iconImgs2 : item.iconImgs" alt="">
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品banner -->
    <img src="@/assets/home/product_banner2.jpg" alt="" class="banner_img" @click="handleMore('newSpecList')">
  
    <!-- 推荐产品 -->
    <div class="tjcp_box">
      <div class="sub_title">
        <span>推荐产品</span>
        <span class="more" @click="handleMore('productList')">查看更多 > </span>
      </div>
      <div class="content">
        <div
          class="item"
          v-for="(item, index) in productList"
          :key="index"
          @click="handleMore('seriesDetails', item.uuid)"
          @mouseenter="activeProduct = index + 1"
          @mouseleave="activeProduct = ''"
        >
          <div class="box_mesg">
            <div class="img_box">
              <img :src="item.imgUrl ? item.imgUrl : '@/assets/home/cp_icon.png'" style="height: 220px"/>
              <div class="copyImg" v-if="activeProduct == index + 1"></div>
              <span v-if="activeProduct == index + 1" class="name_b">{{
                item.name
              }}</span>
          </div>
          <span class="name">{{ item.name }}</span>
          <div class="cs_box">
            <div class="ele" v-for="(ele, ind) in item.params" :key="ind">
              <span>{{ ele.name + "：" }}</span>
              <span class="ele_class">{{ ele.value }}{{ ele.unit }}</span>
            </div>
          </div>
          </div>
          <p class="company">{{ item.company }}</p>
        </div>
      </div>
    </div>
     <!-- banner -->
    <div class="banner_imglistbox">
      <img src="@/assets/home/product_banner.jpeg" alt="" class="banner_imglist" @click="publishProduct">
    </div>

  </div>
</template>

<script>
import Carousel from "@/components/carousel/carousel.vue";
import Parameter from "@/components/parameter/Parameter.vue";
import {getProductList, getProductParams, productTypetree} from "../../utils/product";
import {findSellerSettledInfo, getNewcurrent, getBannerList} from "../../utils/interface";
export default {
  components: {
    Carousel,
    Parameter,
  },
  data() {
    return {
      sbClassIndex: 0,
      bannerList: [],
      classifyList: [],
      xx_query: {
        name: "",
        szm: "",
        cs: [],
      },
      letterList: [...Array(26).keys()].map((i) => String.fromCharCode(i + 65)),
      paramsList: [],
      moreList: [], //更多绑定的数据
      productList: [],
      activeProduct: false,
      backgroudnImg: "",
      paramsListShow: false,
      groupCode: "",
      backgroudnImgBc: ""
    };
  },
  mounted() {
    this.paramsList = this.paramsList.map((m) => {
      return {
        ...m,
        value: m.type == "CHECKBOX" ? [] : "",
      };
    });
    console.log(" this.paramsList ", this.paramsList, this.paramsList);
    this.platformTypetree()
    this.platProductParams()
    this.getRecommendProduct()
    this.getBannerList('CPbanner', 'b');
    this.getBannerList('FLBJ', 'f');
  },
  methods: {
    moreMessage() {
      this.paramsListShow = !this.paramsListShow;
    },
    getBannerList(groupCode, type) {
      getBannerList({groupCode: groupCode}).then((res) => {
        if(type == 'b') {
          this.bannerList = res;
        } else {
        this.backgroudnImgBc = res[0].value;

        }
      });
    },
    platformTypetree() {
      let params = {
        grade: "1",
        type: 'PLATFORM'
      }
      productTypetree(params).then((res) => {
        if(res) {
          this.classifyList = [];
          this.backgroudnImg = res[0].image
          res.forEach((item, index) => {
            this.classifyList.push({
              img: require("@/assets/home/type_icon.jpg"),
              backImg: item.image,
              name: item.label,
              code: item.code,
              uuid: item.value,
              iconImgs: require(`@/assets/home/wei${index}.png`),
              iconImgs2: require(`@/assets/home/xun${index}.png`),
            })
          })
        }
      });
    },
    handleMouseEnter(item, index) {
      this.backgroudnImg = item.backImg
      this.sbClassIndex = index
    },
    // handleMouseLeave() {
    //   this.backgroudnImg = this.classifyList[0].backImg
    // },
    platProductParams() {
      getProductParams({
        origin:'PLATFORM'
      }).then(result=>{
        // this.paramsList = result
        this.paramsList = result.filter(item => item.isSearch)
      })
    },
    getRecommendProduct() {
      let params = {
        recommend: true,
        current: 1,
        pageSize: 8
      }
      getProductList(params).then((res) => {
        this.productList = res.list
      });
    },
    handleSZM(item) {
      if (this.xx_query.szm == item) {
        this.xx_query.szm = "";
      } else {
        this.xx_query.szm = item.toLowerCase();
      }
      let queryParams = {chinesePinYin:this.xx_query.szm}
      this.toProductList(queryParams)
    },
    handleInputMesg(item) {
      let queryParams = {name:this.xx_query.name}
      this.toProductList(queryParams)
      this.xx_query.name =  ""
    },
    //点击更多绑定的参数数据
    parameterChange(info) {
      //info为reset则重置
      // console.log("更多改变", info);
      if (info == "reset") {
        this.paramsList = this.paramsList.map((m) => {
          return {
            ...m,
            value: m.type == "CHECKBOX" ? [] : "",
          };
        });
        this.xx_query.cs = [];
        this.xx_query.name = "";
        this.xx_query.szm = "";
      } else {
        this.moreList = info;
      }
    },
    //开始选型
    searchXX() {
      // let list = this.paramsList
      //   .filter((ele, ind) => {
      //     return ind < 3;
      //   })
        // .concat(this.moreList);
      this.xx_query.cs = this.paramsList.map((m) => {
        return {
          name: m.name,
          value: m.value,
          uuid: m.uuid,
        };
      });
      // 带数据跳转
      //   let routeData = this.$router.resolve({
      //   name: 'productList',
      // });
      // window.open(routeData.href, "_blank");
      console.log(this.xx_query);
      let queryParams = {params:this.xx_query.cs}
      this.toProductList(queryParams)
    },

    //产品列表
    handleMore(type, uuid) {
      if ("newSpecList"===type && !this.$store.state.isLogin) {
        this.$message.warning("您需要先登陆哦！");
        this.$router.push({
          name: "login",
        });
        return false;
      }else if ("newSpecList"===type && (this.$store.state.isUsermessage.identity === 'PERSONAL' || this.$store.state.isUsermessage.identity === 'ANONYMOUS')) {
        this.$confirm('请先进行企业资质认证!', '提示', {
          confirmButtonText: '去认证',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.sessionStorage.setItem("userServeId", "11");
          let routeData = this.$router.resolve({
                name: "userCenter",
                params: {
                  userServeId: '11',
                },
              });
          window.open(routeData.href, "_target");
        });
        return false;
      }else{
        let routeData = this.$router.resolve({
          name: type,
        });
        let href = routeData.href;
        if(type === 'seriesDetails') {
          href += "?uuid=" + uuid;
        }
        window.open(href, "_blank");
      }
    },
    getSClass(i) {
      this.sbClassIndex = i;
      let code = this.classifyList[i].code;
      let queryParams = {platformTypeCode:code}
      this.toProductList(queryParams)
    },
    toProductList(params) {
      let routeData = this.$router.resolve({
        name: "productList",
      });
      let href = routeData.href;
      href += "?params=" + JSON.stringify(params);
      window.open(href, "_blank");
    },

    publishProduct() {
      if (this.$store.state.isLogin) {
        getNewcurrent().then((data) => {
          this.identity = data.identity;
          if (this.identity === 'ENTERPRISE') {
            let routeData = this.$url['sellerWeb'] + '#submitProduct';
            this.$cookies.set("authoritiesMess", "sellerCenterService");
            if (routeData != "") {
              window.open(routeData, "_blank");
            }
          } else if (this.identity === 'PERSONAL' || this.identity === 'ANONYMOUS') {
            this.$confirm('请先进行企业资质认证!', '提示', {
              confirmButtonText: '去认证',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              window.sessionStorage.setItem("userServeId", "11");
              let routeData = this.$router.resolve({
                name: "userCenter",
                params: {
                  userServeId: '11',
                },
              });
              window.open(routeData.href, "_target");
            });
          }
        })
      } else {
          let routeData = this.$url['sellerWeb'] + '#/loginIndex';
          if (routeData != "") {
            window.open(routeData, "_blank");
          }
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-input-group__append {
  background-color: #009999 !important;
  color: #fff;
  border: 1px solid #009999 !important;
}
/deep/ .el-form--inline .div__label {
  color: #fff;
  font-size: 16px;
}
/deep/ .el-input__suffix {
  display: flex;
  align-items: center;
}
/deep/.el-popover {
  left: 0;
  top: 71px;
}
/deep/.parameter {
  width: 1109px;
}
.banner {
  position: relative;
  .el-button {
    z-index: 99;
    position: absolute;
    top: 68%;
    left: 26%;
    transform: translate(-38%, -30%);
  }
}
.home {
  width: 100%;
  .sub_title {
    font-size: 20px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 600;
    margin: 30px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    // padding-left: 10px;
    // border-left: 3px solid #099;
    height: 20px;
    position: relative;
    .more {
      font-size: 14px;
      color: #000;
      font-weight: 400;
      cursor: pointer;
      position: absolute;
      right: 0;
      &:hover {
        color: #009999;
      }
    }
  }
  .sbfl_box {
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .sbfl {
    width: 1200px;
    margin: 0 auto;
    .content {
      .fl_box {
        // width: 1200px;
        height: 555px;
        background-image: url("../../assets/home/classBanner.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
        transition:all 0.8s ease;
        .fl_box_mesg {
          position: absolute;
          top: 54%;
          left: 50%;
          transform: translate(-40%, -50%);
          width: 1200px;
          .fl_box_p {
            width: 214px;
            height: 56px;
            // background-image: url("../../assets/home/wei0.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin-bottom: 20px;
            color: #fff;
            font-size: 18px;
            font-weight: bold;
            text-align: center;
            line-height: 56px;
            cursor: pointer;
            position: relative;
            &:hover {
              width: 234px;
              height: 67px;
              line-height: 67px;
              // background: url("../../assets/home/xun0.png") no-repeat;
              background-size: 100% 100%;
              color: #000;
            }
            span {
              position: absolute;
              top: 0;
              left: 50%;
              transform: translate(-40%, 0);
            }
          }
          .active {
            width: 234px;
            height: 67px;
            line-height: 67px;
            // background: url("../../assets/home/xun0.png") no-repeat;
            background-size: 100% 100%;
            color: #000;
            span {
              position: absolute;
              top: -1%;
            }
          }
        }
      }
    }
    .sub_title {
      margin: 0;
      padding-top: 40px;

    }
  }
  .xx_box {
    width: 100%;
    // height: 336px;
    background-color:#f8f8f8;
    // background-image: url("../../assets/home/xx_bg.jpg");
    // background-size: 100% 100%;
    background-blend-mode: screen;
    // margin-bottom: 20px;
    padding: 22px 0 0;
    .sub_title {
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .xx_main {
      width: 1109px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .black_text {
      font-size: 30px;
      font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
      font-weight: 800;
      color: #333333;
    }
    .box1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;
      position: relative;
      .red_text {
        font-size: 14px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #333333;
      }
      .xx_input {
        width: 1000px;
        height: 47px;
        background: #ffffff;
        border-radius: 22px;
        /deep/.el-input__inner {
          width: 1000px;
          height: 47px;
          background: #ffffff;
          border-radius: 22px;
        }
      }
      .searchP {
        width: 86px;
        background: #099;
        color: #fff;
        border-radius: 0 20px 20px 0;
        height: 47px;
        position: absolute;
        right: 0;
        top: 0;
        line-height: 47px;
        text-align: center;
        font-size: 24px;
      }
    }
    .box2 {
      width: 1000px;
      height: 38px;
      margin: 0 auto;
      background: #e6e6e6;
      border: 1px solid #e6e6e6;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-bottom: 20px;
      margin-top: 10px;
      .item {
        height: 25px;
        line-height: 25px;
        text-align: center;
        font-weight: 600;
        font-size: 14px;
        color: #333;
        cursor: pointer;
      }
      .item:hover {
        color: #099;
        border-bottom: 1px solid #099;
      }
      .activeItem {
        color: #099;
        border-bottom: 1px solid #099;
      }
    }
    .box3 {
      display: flex;
      position: relative;
      align-items: center;
      flex-wrap: wrap;
      .item {
        display: inline-block;
        margin-right: 10px;
        width: 19%;
        div {
          display: flex;
          align-items: center;
          .name {
            color: #000;
            font-size: 14px;
            width: 88px;
            font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
            font-weight: 400;
            display: inline-block;
            margin-right: 5px;
            white-space: nowrap;
            flex-shrink: 0;
            text-align: right;
          }
        }
        /deep/.el-input__inner {
          height: 32px;
          line-height: 32px;
        }
      }
      .btn {
        width: 113px;
        height: 43px;
        line-height: 43px;
        background: #099;
        // background: linear-gradient(45deg,#01e9bd, #007cde );
        border-radius: 5px 5px 5px 5px;
        color: #fff;
        text-align: center;
        cursor: pointer;
      }
      
    }
    .more_bt {
      font-size: 12px;
      margin: 15px;
      text-align: center;
      cursor: pointer;
      white-space: nowrap;
      color: #999;
      img {
        width: 10px;
      }
    }
  }
  .tjcp_box {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .content {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-column-gap: 16px;
      flex-wrap: wrap;
      .item {
        // flex: 0 0 calc(100% / 4 - 26px);
        padding-bottom: 15px;
        border-radius: 20px;
        box-shadow: 4px 4px 10px #dddcdc;
        cursor: pointer;
        // padding: 10px;
        overflow: hidden;
        text-align: center;
        margin-bottom: 20px;
        .box_mesg {
          background: #f3f3f3;
          padding: 10px;
        }
        .img_box {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            width: 100%;
          }
          .copyImg {
            width: 100%;
            height: 220px;
            background: #43434378;
            position: absolute;
            top: 0;
          }
          .name_b {
            position: absolute;
            bottom: 100px;
            padding: 8px 15px;
            border: 1px solid #fff;
            color: #fff;
            font-size: 16px;
            font-weight: 600;
          }
        }

        .name {
          font-size: 16px;
          display: inline-block;
          color: #333333;
          font-weight: 600;
          margin: 15px 0;
          letter-spacing: 1px;
          overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            width: 95%;
        }
        .cs_box {
          border-top: 1px dotted rgba(215, 215, 215, 1);
          padding: 10px 20px;
          .ele {
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #333;
            font-size: 14px;
            .ele_class {
              display: inline-block;
              min-width: 60px;
              text-align: left;

            }
          }
          .ele:last-child {
            margin-bottom: 0;
          }
        }
        .company {
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 1px;
          padding: 15px 0;
        }
      }
      .item:hover {
        img,.copyImg {
          transform: scale(1.1);
        }
      }
    }
  }
  .banner_img {
    width: 100%;
    background: #000;
    cursor: pointer;
  }
  .banner_imglistbox {
    cursor: pointer;
    .banner_imglist {
      width: 100%;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/index.vue